<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Approval Required</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">

      
        <div class="row">
            <!-- ngIf Added by rahul yadav on 31/05/2021 -->
            <div class="col-sm-6" *ngIf="SaleType!='LL'"> 
                <div class="form-group row text-left">
                    <label for="lblTotalCustMif" class="col-sm-4 col-form-label">Total Customer Machine
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtTotalCustMif" type="number" [(ngModel)]="SpraApprovalParams.TotalCustMif">
                            
                        </div>

                    </div>
                </div>
            </div>

<!-- ngIf Added by rahul yadav on 31/05/2021 -->
            <div class="col-sm-6" *ngIf="SaleType!='LL'">
                <div class="form-group row text-left">
                    <label for="lblSharpMifCustomerPlace" class="col-sm-4 col-form-label">Sharp Machine at customer place
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtSharpMifCustomerPlace" type="number" [(ngModel)]="SpraApprovalParams.SharpMifCustomerPlace">
                        </div>

                    </div>
                </div>
            </div>
        </div>
          
        <div class="row">


            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblPriceRef" class="col-sm-4 col-form-label">Price Ref Type</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlPriceRefType" name="ddlPriceRefType" class="form-control" [(ngModel)]="SpraApprovalParams.PriceRefType">
                                <option value="New">New</option>
                                <option value="Existing">Existing </option>
                            </select>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblPriceRef" class="col-sm-4 col-form-label">Price Ref No</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                           <!-- commented by yadav <input class="form-control " name="txtPriceRef" [(ngModel)]="SpraApprovalParams.PriceRef"> -->
                            <!-- <i class="fa fa-link fa-lg" aria-hidden="true"></i> -->
                            <!-- (click)="d.toggle()" -->
                            <div class="input-group-append">
                                <button class="btn btn-light fa fa-link fa-lg" [disabled]="Mode!='I'" (click)="openSpraList()" 
                                    type="button"></button>
                            </div>
                            <button type="button" class="btn btn-link" (click)="openSpraView()">{{SpraApprovalParams.PriceRef}}</button>
                           
               
                        </div>
                        
                    </div>
                </div>
            </div>

        </div>
        <div class="row" *ngIf="!IsRental">        
           <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblWarrentyMonth" class="col-sm-4 col-form-label">Warranty Month
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                         <select id="ddlWarrentyMonth" name="ddlWarrentyMonth" [disabled]="SpraApprovalParams.DayOneCSA || !IsSpraHaveFinishGood"  [(ngModel)]="SpraApprovalParams.WarrantyMonth"
                             class="form-control">
                              <option *ngFor="let wm of WarrentyMonthList" value={{wm.warrantyMonth}}>
                                {{wm.warrantyCaption}}      
                            </option>
                            </select>

                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblExtraWarrentyPeriod" class="col-sm-4 col-form-label">Extra warranty Period
                        <span class="font-red-flamingo">(In Months)</span>
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtExtraWarrentyPeriod" type="number" [disabled]="SpraApprovalParams.WarrantyMonth == undefined || SpraApprovalParams.WarrantyMonth<=0 || SpraApprovalParams.DayOneCSA" [(ngModel)]="SpraApprovalParams.ExtraWarrentyPeriod">
                        </div>

                    </div>
                </div>
            </div>
        </div>

            <div class="row" *ngIf="!IsRental">
                <div class="col-sm-6" *ngIf="ProfitTag">
                    <div class="form-group row text-left">
                        <label for="lblWarrentyCost" class="col-sm-4 col-form-label">Warranty Cost
                            </label>
                            <div class="col-sm-3">
                                <div class="input-group">
                                    <input class="form-control " name="txtWarrentyPercentage" (input)="CalculateWarrentyCost()" placeholder="Percentage" type="number" [disabled]="SpraApprovalParams.WarrantyMonth == undefined || SpraApprovalParams.WarrantyMonth<=0 || SpraApprovalParams.ExtraWarrentyPeriod== undefined || SpraApprovalParams.ExtraWarrentyPeriod <= 0 || SpraApprovalParams.DayOneCSA" [(ngModel)]="SpraApprovalParams.WarrentyPercentage">
                                    <span class="mt-2 pl-2"><b>%</b></span>    
                                </div>        
                            </div>
                        <div class="col-sm-5">
                            <div class="input-group">
                                
                                <input class="form-control " name="txtWarrentyCost" type="number" disabled="true" [(ngModel)]="SpraApprovalParams.WarrentyCost">
                            </div>
    
                        </div>
                    </div>
                </div>



                <div class="col-sm-6" *ngIf="IsSpraHaveCopMfd && IsSpraHaveFinishGood && SaleType!='LL'">
                    <div class="form-group row text-left">
                        <label class="col-sm-4 col-form-label">
                            Day One CSA 
                        </label>
                        <div class="col-sm-8">
                            <div class="input-group">
                                <mat-checkbox color="primary" #chkDayOneCSA [(ngModel)]="SpraApprovalParams.DayOneCSA" (change)="chkDayOneCSAClick(true)" aria-disabled="(!SpraApprovalParams.IsSpraHaveFinishGood) ? false : true" ><span class="font-red-flamingo">(Select "Yes" )</span></mat-checkbox>
                            </div>
                        </div>
    
                    </div>
                </div>




<div class="col-sm-6" *ngIf="!IsRental">
                      <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
                <div class="form-group row text-left" *ngIf="SaleType!='DD'"> 
                    <label  class="col-sm-4 col-form-label">TOI
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlTOI" name="ddlPriceRefType" class="form-control" [(ngModel)]="SpraApprovalParams.TOI">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>

                    </div>
                </div>
            </div>


            <div class="col-sm-6" *ngIf="!IsRental">
                  <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
                <div class="form-group row text-left" *ngIf="SaleType!='DD'">
                    <label  class="col-sm-4 col-form-label">Incentive Trip For Sales	
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlTOI" name="ddlIncentiveSales" class="form-control" [(ngModel)]="SpraApprovalParams.IncentiveSales">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="!IsRental" >
                  <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
                <div class="form-group row text-left" *ngIf="SaleType!='DD'">
                    <label  class="col-sm-4 col-form-label">Incentive Trip For Dealer
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlTOI" name="ddlIncentiveDealer" class="form-control" [(ngModel)]="SpraApprovalParams.IncentiveDealer">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="!IsRental">
                  <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
                <div class="form-group row text-left" *ngIf="SaleType!='DD'">
                    <label  class="col-sm-4 col-form-label">Over Due
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlTOI" name="ddlOverDue" class="form-control" [(ngModel)]="SpraApprovalParams.OverDue">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>

                    </div>
                </div>
            </div>

              <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
            <div class="col-sm-6" *ngIf="!IsRental && SaleType!='DD'">                
                <div class="form-group row text-left">
                    <label  class="col-sm-4 col-form-label">Cons Order Value This Month	
                        <span class="font-red-flamingo">(In K)</span>
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            
                            <input class="form-control " name="txtConsValueThisMonth" type="number" [(ngModel)]="SpraApprovalParams.ConsValueThisMonth">                          
                        </div>

                    </div>
                </div>
            </div>

            <!-- SaleType check Added by rahul yadav on 25/05/2021 -->
            <div class="col-sm-6" *ngIf="!IsRental && SaleType!='DD'">                  
                <div class="form-group row text-left">
                    <label  class="col-sm-4 col-form-label">End Customer Order Copy	
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlECOC" name="ddlECOC" class="form-control" [(ngModel)]="SpraApprovalParams.ECOC">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>

                    </div>
                </div>
            </div>








            </div>
      

            <div class="row" *ngIf="IsRental">
                <!-- *ngIf="IsSpraHaveCopMfd && SaleType!='LL'" -->
                <div class="col-sm-6" >
                    <div class="form-group row text-left">
                        <label class="col-sm-4 col-form-label">
                            Sharp Rental Terms & Condition Aceepted by Customer (Yes / No)			
                        </label>
                        <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlRentalTermAccept" name="ddlRentalTermAccept" class="form-control" [(ngModel)]="SpraApprovalParams.RentalTermAccept">
                                <option value="Yes">Yes</option>
                                <option value="No">No </option>
                            </select>                            
                        </div>
                    </div>
                        <!-- <div class="col-sm-8">
                            <div class="input-group">
                                <mat-checkbox color="primary"   [(ngModel)]="SpraApprovalParams.RentalTermAccept"  ><span class="font-red-flamingo">(Select "Yes" )</span></mat-checkbox>
                            </div>
                        </div> -->
    
                    </div>
                </div>


            </div>

            
<div class="row">
    <!-- Removed by rajan singh on 17/06/2021 -- after discussion with Mr. anand -->
    <!-- && SaleType!='LL' -->
            <div class="col-sm-6" *ngIf="IsSpraHaveCopMfd && IsSpraHaveFinishGood" >
                <div class="form-group row text-left">
                    <label for="lblBlackA3CopyRatio" class="col-sm-4 col-form-label">Black A3 Copy Ratio
                        <span class="font-red-flamingo">In Integer (eg. 1)</span>
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtBlackA3CopyRatio" (input)="A3CopyRatioChange()" [(ngModel)]="SpraApprovalParams.BlackA3CopyRatio">
                        </div>

                    </div>
                </div>
            </div>
            <!-- Removed by rajan singh on 17/06/2021 -- after discussion with Mr. anand -->
            <!-- && SaleType!='LL' -->
            <div class="col-sm-6" *ngIf="IsSpraHaveCopMfd && IsSpraHaveFinishGood " >
                <div class="form-group row text-left">
                    <label for="lblColorA3CopyRatio" class="col-sm-4 col-form-label">Color A3 Copy Ratio
                        <span class="font-red-flamingo">In Integer (eg. 1)</span>
                        </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control " name="txtColorA3CopyRatio" (input)="A3CopyRatioChange()" [(ngModel)]="SpraApprovalParams.ColorA3CopyRatio">
                        </div>

                    </div>
                </div>
            </div>

            

            <div [class]="Mode!='I'? 'col-sm-12':'col-sm-6' " *ngIf="SpraCsaRateArray.length>0 && SaleType!='LL'">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Counter</th>
                            <th>ExistingCSARate</th>
                            <th> Order Rate </th>
                            <th *ngIf="ProfitTag"> Price List </th>
                            <th *ngIf="ProfitTag"> Landed Cost-Worksheet </th>
                            <th *ngIf="ProfitTag"> GP% </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of SpraCsaRateArray; let i = index;">
                            
                            <td>
                                {{item.CounterDesc}}
                            </td>
                            <td>
                                
                                {{item.ExistingCSARate!=""?item.ExistingCSARate:"NA"}}
                            </td>
                            <td>
                                <input type="number" name="txtOrderRate" (input)="chkDayOneCSAClick(false)" [(ngModel)]="item.OrderRate" class="form-control">
                            </td>
                            <td *ngIf="ProfitTag"> {{item.PriceList}} </td>
                            <td *ngIf="ProfitTag"> {{item.WorkSheetLanded}} </td>
                            <td *ngIf="ProfitTag"> {{item.GP}} % </td>
                           
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>




        


    </mat-card-content>
</mat-card>